import AddIcon from '@mui/icons-material/Add';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIconButton from '../components/DeleteIconButton';
import SettingsIcon from '@mui/icons-material/Settings';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import EditIcon from '@mui/icons-material/BorderColorOutlined';
import { Autocomplete, Button, Dialog, Divider, FormControlLabel, Grid, IconButton, ListItem, ListItemAvatar, ListItemText, 
    Radio, Switch, TextField, Tooltip, Typography, FormControl, FormHelperText, Select, InputLabel, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { useSnackbar } from 'notistack';

import { copyTextToClipboard } from '../utils';
import ConfirmationDialog from '../components/ConfirmationDialog';
import FormActionButtons from '../components/FormActionButtons';
import RecordList from '../components/RecordList';
import { ContextStore } from '../store/contextStore';
import { useIsWidthUp } from '../utils';
import { ConfirmationDialogText, DELIVERY_ADVANCED, DELIVERY_ALL, DELIVERY_FIRST, DELIVERY_METHOD_CHAT, DELIVERY_METHOD_CHAT_DESTINATION, 
    DELIVERY_METHOD_EMAIL, DELIVERY_METHOD_EMAIL_DESTINATION, DELIVERY_METHOD_SMS, DELIVERY_METHOD_SMS_DESTINATION, DELIVERY_METHOD_WHATSAPP, 
    DELIVERY_METHOD_WHATSAPP_DESTINATION, DELIVERY_METHOD_AIRBNB, DELIVERY_METHOD_AIRBNB_DESTINATION, DELIVERY_METHODS, DELIVERY_ORDERING, deliveryMethodsOptions, EMAIL_TO_ADDRESS, EMAIL_TO_SUPPORT, 
    NON_ADMIN_DELIVERY_METHODS, RENDERING_TYPE_CUSTOM, SMS_TO_NUMBER, SMS_TO_SUPPORT, WHATSAPP_TO_NUMBER, 
    WHATSAPP_TO_SUPPORT, RENDERING_TYPE_STANDARD, DELIVERY_METHOD_HTTP_REQUEST, HTTP_METHOD_POST,
    AIRBNB_TO_ARBITRARY_THREAD_ID,
    httpMethodMenuItems} from './utils';
import { RemoteAutocomplete as StandardRemoteAutocomplete }  from '../components/RemoteAutocomplete';
import StandardNotificationSettingsDialog from './StandardNotificationSettingsDialog';

const useStyles = makeStyles((theme) => ({
    toolbarContainer: {
        border: '1px solid #D8D8D8',
        borderRadius: '12px',
        padding: '0',
    },
    recordList: {
        padding: 0,
        margin: 0,
        [theme.breakpoints.up('sm')]: {
            height: '600px !important',
            minHeight: '600px !important',
            maxHeight: '600px !important',
            border: 'none !important',
        },
    },
}));

const compare = (a, b) => {
    if (a.sequence < b.sequence) {
        return -1;
    }
    if (a.sequence > b.sequence) {
        return 1;
    }
    return 0;
};

const DeliveryMethodList = (props) => {
    const { notification, relatedLoading, setNotification, handleSave } = props;
    const { user, hasPerm } = React.useContext(ContextStore);
    const classes = useStyles();
    const [newRowOrder, setNewRowOrder] = React.useState(null);
    const [newDeliveryMethod, setNewDeliveryMethod] = React.useState({
        notification: notification.id,
        method: null,
    });
    const [lastUpdate, setLastUpdate] = React.useState(null);
    const isSmallScreen = !useIsWidthUp('sm');
    const history = useHistory();
    const isAdmin = user.email.indexOf('@curatedplanet.com') > 0;
    const [toDelete, setToDelete] = useState(null)
    const [confirmationDialogAction, setConfirmationDialogAction] = React.useState(null);
    const [nfSettingsRow, setNfSettingsRow] = React.useState(null);
    const [httpHeadersDialogOpen, setHttpHeadersDialogOpen] = useState(null);
    const [headersEditValue, _setHeadersEditValue] = useState('');
    const headersEditValueRef = React.useRef('');
    const setHeadersEditValue = (v) => { headersEditValueRef.current = v; _setHeadersEditValue(v); };
    const [headersEditError, setHeadersEditError] = useState(null);
    const disabled = props.disabled
    const { enqueueSnackbar } = useSnackbar();

    const copyToClipboard = (text, label) => {
        if (text) {
            copyTextToClipboard(text);
            enqueueSnackbar(label ? `${label} copied!` : 'Copied!', { variant: 'success', autoHideDuration: 500 });
        } else {
            enqueueSnackbar(label ? `${label} is empty!` : 'Cannot copy empty string!', { variant: 'error', autoHideDuration: 500 });
        }
    };

    const deliveryMethodsShown = () => {
        let optionsShown = deliveryMethodsOptions;

        if (notification.event === 'user.message_received') {
            optionsShown = optionsShown.filter((dm) => parseInt(dm.id) !== DELIVERY_METHOD_CHAT);
        }

        if (notification.event === 'user.recent_messages_notification') {
            optionsShown = optionsShown.filter((dm) => parseInt(dm.id) !== DELIVERY_METHOD_CHAT);
        }

        if (notification.event === 'user.unread_notification') {
            optionsShown = optionsShown.filter((dm) => parseInt(dm.id) !== DELIVERY_METHOD_CHAT);
        }

        // Chatbot handoff alerts -- and the team email once a website visitor leaves an
        // address -- go to the team, never into the visitor's conversation (the backend
        // blacklists chat delivery for these events too).
        if (notification.event === 'user.chatbot_handoff' || notification.event === 'user.web_widget_contact_captured') {
            optionsShown = optionsShown.filter((dm) => parseInt(dm.id) !== DELIVERY_METHOD_CHAT);
        }

        if (!isAdmin) {
            // These options are disabled for everyone for now, so commenting them out here
            //optionsShown = optionsShown.filter((dm) => parseInt(dm.id) !== DELIVERY_METHOD_SENTRY &&
            //                                           parseInt(dm.id) !== DELIVERY_METHOD_SNS_TOPIC &&
            //                                           parseInt(dm.id) !== DELIVERY_METHOD_HTTP_REQUEST)
        }

        if (notification.event && notification.event.startsWith('tour_departure.')) {
            optionsShown = optionsShown.filter((dm) => [DELIVERY_METHOD_EMAIL, DELIVERY_METHOD_CHAT].indexOf(parseInt(dm.id)) >= 0);
        }
        return optionsShown;
    };

    const listItemRenderer = (row, idx, rows, gridApi) => {
        return (
            <React.Fragment key={idx}>
                {idx === rows.length - 1 ? <Divider /> : null}
                <ListItem alignItems="center">
                    <ListItemAvatar
                        onClick={(e) => {
                            e.preventDefault();
                            history.push('/notifications/' + notification.id + '/' + row.id);
                        }}
                    >
                        {row.enabled ? <Tooltip title="Enabled"><CheckCircleIcon color="primary" fontSize="large" /></Tooltip> : <Tooltip title="Disabled"><CancelIcon fontSize="large" color="secondary" /></Tooltip>}
                    </ListItemAvatar>
                    <ListItemText
                        onClick={(e) => {
                            e.preventDefault();
                            history.push('/notifications/' + notification.id + '/' + row.id);
                        }}
                        primary={DELIVERY_METHODS[row.method]}
                        secondary={row.email_replyto}
                    />
                    <Switch
                        checked={row?.enabled}
                        onChange={(e) => {
                            e.preventDefault();
                            onRecordListSwitchChange(e, row.id);
                        }}
                        name="enabled"
                        color="primary"
                    />
                </ListItem>
                <Divider />
            </React.Fragment>
        );
    };

    const onRecordListSwitchChange = (ev, id) => {
        ev.preventDefault();
        setNotification((prev) => {
            let delivery_methods = prev.delivery_methods;
            let upd = delivery_methods.filter((dm) => dm.id === id)[0];
            return {
                ...prev,
                delivery_methods: [...delivery_methods.filter((dm) => dm.id !== id), { ...upd, enabled: !upd.enabled }].sort(compare),
            };
        });
    };

    const onToggleRenderingType = (row, field, ev) => {
        setNotification((prev) => {
            let delivery_methods = prev.delivery_methods;
            let upd = delivery_methods.filter((dm) => dm.id === row.id)[0];
            upd[field] = ev.target.checked ? RENDERING_TYPE_CUSTOM : RENDERING_TYPE_STANDARD;
            console.log('toggle rendering type', field, row, upd);
            return {
                ...prev,
                delivery_methods: [...delivery_methods.filter((dm) => dm.id !== row.id), upd].sort(compare),
            };
        });
    }

    const onHttpMethodChange = (row, value) => {
        setNotification((prev) => {
            let delivery_methods = prev.delivery_methods;
            let upd = delivery_methods.filter((dm) => dm.id === row.id)[0];
            upd.http_method = value;
            return {
                ...prev,
                delivery_methods: [...delivery_methods.filter((dm) => dm.id !== row.id), upd].sort(compare),
            };
        });
    }

    const onHttpUrlChange = (row, value) => {
        setNotification((prev) => {
            let delivery_methods = prev.delivery_methods;
            let upd = delivery_methods.filter((dm) => dm.id === row.id)[0];
            upd.http_url = value;
            return {
                ...prev,
                delivery_methods: [...delivery_methods.filter((dm) => dm.id !== row.id), upd].sort(compare),
            };
        });
    }

    const onHttpHeadersChange = (rowId) => {
        const value = headersEditValueRef.current;
        let parsed;
        try {
            parsed = value ? JSON.parse(value) : {};
            if (parsed && typeof parsed !== 'object') {
                throw new Error('Input must be a JSON object');
            }
        } catch (e) {
            setHeadersEditError('Invalid JSON: ' + e.message);
            return;
        }
        setNotification((prev) => {
            const dms = prev.delivery_methods.map((dm) => {
                return dm.id === rowId ? { ...dm, http_headers: parsed } : dm;
            });
            return { ...prev, delivery_methods: dms };
        });
        setHeadersEditError(null);
        setHttpHeadersDialogOpen(null);
    }

    const onStandardTemplateSelect = (row, nv, field, reason) => {
        console.log('standard template select', field, row, nv);
        setNotification((prev) => {
            let delivery_methods = prev.delivery_methods;
            let upd = delivery_methods.filter((dm) => dm.id === row.id)[0];
            upd[field] = nv;
            return {
                ...prev,
                delivery_methods: [...delivery_methods.filter((dm) => dm.id !== row.id), upd].sort(compare),
            };
        });
    }

    const onDuplicate = (id) => {
        let to_duplicate = notification.delivery_methods.filter((dm) => dm.id === id)[0];

        let new_notification_data = {
            ...notification,
            delivery_methods: [
                ...notification.delivery_methods,
                {
                    ...to_duplicate,
                    id: Math.floor(Math.random() * Math.floor(Math.random() * Date.now())),
                    enabled: false,
                    created: true,
                    sequence: notification.delivery_methods.length,
                },
            ],
        };
        handleSave(new_notification_data);
    };

    const onRowOrderUpdate = (upd) => {
        const newOrder = { ...newRowOrder, ...upd };
        setNewRowOrder(newOrder);
        setNotification((prev) => {
            let sequence_keys = Object.keys(upd);
            let selected_id = prev.delivery_methods.filter((dm) => dm.id.toString() === sequence_keys[0])[0];
            let next_id = prev.delivery_methods.filter((dm) => dm.id.toString() === sequence_keys[1])[0];
            let removed_previous_options = prev.delivery_methods.filter((option) => option.id.toString() !== sequence_keys[0] && option.id.toString() !== sequence_keys[1]);

            return {
                ...prev,
                delivery_methods: [...removed_previous_options, { ...selected_id, sequence: upd[sequence_keys[0]] }, { ...next_id, sequence: upd[sequence_keys[1]] }].sort(compare),
            };
        });
    };

    const handleAddNewDeliveryMethod = () => {
        setNotification((prev) => {
            const newNotificationData = { ...prev };
            const new_delivery_method = {
                ...newDeliveryMethod,
                id: Math.floor(Math.random() * Math.floor(Math.random() * Date.now())),
                enabled: false,
                created: true,
                sequence: prev.delivery_methods.length,
                http_method: HTTP_METHOD_POST,
            };

            if (prev.event && prev.event.startsWith('tour_departure.')) {
                new_delivery_method.email_destination = EMAIL_TO_ADDRESS;
            }

            newNotificationData.delivery_methods = [
                ...newNotificationData.delivery_methods,
                new_delivery_method,
            ];

            handleSave(newNotificationData);

            return newNotificationData;
        });
        setLastUpdate(new Date().toString());
        setNewDeliveryMethod({ notification: notification.id, method: null });
    };

    const handleNewDeliveryMethodTypeChange = (ev, dm) => {
        if (!dm) {
            setNewDeliveryMethod((prev) => ({
                notification: notification.id,
                method: null,
            }));
            return;
        }
        setNewDeliveryMethod((prev) => ({ ...prev, method: parseInt(dm.id) }));
    };



    const formatRecipientBasedOnMethod = (p) => {
        // (p) => {
        //     return (
        //         <>
        //             <Typography>{formatRecipientBasedOnMethod(p.row)}</Typography>
        //         </>
        //     );
        // }        
        const delivery_method = p.row;
        if (delivery_method.method === DELIVERY_METHOD_EMAIL) {
            if (delivery_method.email_destination === EMAIL_TO_ADDRESS) {
                return <Typography>{delivery_method.email_address}</Typography>;
            }
            if (delivery_method.email_destination === EMAIL_TO_SUPPORT) {
                return <Typography>{delivery_method.email_support?.name}</Typography>;
            }
            return <Typography>{DELIVERY_METHOD_EMAIL_DESTINATION[delivery_method.email_destination]}</Typography>;
        }
        if (delivery_method.method === DELIVERY_METHOD_CHAT) {
            return <Typography>{DELIVERY_METHOD_CHAT_DESTINATION[delivery_method.chat_destination]}</Typography>;
        }
        if (delivery_method.method === DELIVERY_METHOD_SMS) {
            if (delivery_method.sms_destination === SMS_TO_NUMBER) {
                return <Typography>{delivery_method.sms_number}</Typography>;
            }
            if (delivery_method.sms_destination === SMS_TO_SUPPORT) {
                return <Typography>{delivery_method.sms_support?.contact}</Typography>;
            }
            return <Typography>{DELIVERY_METHOD_SMS_DESTINATION[delivery_method.sms_destination]}</Typography>;
        }
        if (delivery_method.method === DELIVERY_METHOD_WHATSAPP) {
            if (delivery_method.whatsapp_destination === WHATSAPP_TO_NUMBER) {
                return <Typography>{delivery_method.whatsapp_number}</Typography>;
            }
            if (delivery_method.whatsapp_destination === WHATSAPP_TO_SUPPORT) {
                return <Typography>{delivery_method.whatsapp_support?.contact}</Typography>;
            }
            return <Typography>{DELIVERY_METHOD_WHATSAPP_DESTINATION[delivery_method.whatsapp_destination]}</Typography>;
        }
        if (delivery_method.method === DELIVERY_METHOD_AIRBNB) {
            if (delivery_method.airbnb_destination === AIRBNB_TO_ARBITRARY_THREAD_ID) {
                return <Typography>{delivery_method.airbnb_thread_id}</Typography>;
            }
            return <Typography>{DELIVERY_METHOD_AIRBNB_DESTINATION[delivery_method.airbnb_destination]}</Typography>;
        }
        if (delivery_method.method === DELIVERY_METHOD_HTTP_REQUEST) {
            return (<TextField
                variant="filled"
                color="primary"
                title={delivery_method.http_url}
                label={`Target URL`}
                size="small"
                value={delivery_method.http_url}
                onChange={(ev) => onHttpUrlChange(delivery_method, ev.target.value)}
                fullWidth
                InputProps={{
                    endAdornment: (
                        <Tooltip title="Copy URL">
                            <IconButton
                                aria-label="copy target URL to clipboard"
                                onClick={() => {
                                    copyToClipboard(delivery_method.http_url, 'Target URL');
                                }}
                                edge="end"
                            >
                                <FileCopyIcon />
                            </IconButton>
                        </Tooltip>
                    ),
                }}
            />);
        }
        return;
    };


    const handleDeleteDeliveryMethod = (ev, id) => {
        setToDelete(id)
        setConfirmationDialogAction('delete_delivery_method')
    };

    const doDeleteDeliveryMethod = () => {
        let id = toDelete;
        let new_notification_data = {};
        setNotification((prev) => {
            //Generate new sequence for all delivery methods
            let delivery_methods = prev.delivery_methods.filter((dm) => dm.id !== id);

            for (let index = 0; index < delivery_methods.length; index++) {
                delivery_methods[index].sequence = index;
            }
            new_notification_data = { ...prev, delivery_methods: delivery_methods };
            return { ...prev, delivery_methods: delivery_methods };
        });

        handleSave(new_notification_data);
    };

    const confirmationDialogCancel = () => {
        setConfirmationDialogAction(null);
    };

    const confirmationDialogConfirm = () => {
        switch (confirmationDialogAction) {
            case 'delete_delivery_method':
                doDeleteDeliveryMethod();
                break;
            default:
                break;
        }
        confirmationDialogCancel();
    };

    const getRowRenderingType = (row) => {
        let rt = +RENDERING_TYPE_CUSTOM;
        let field = null;
        switch (row.method) {
            case DELIVERY_METHOD_EMAIL: rt = +row.email_rendering_type; field = 'email'; break;
            case DELIVERY_METHOD_SMS: rt = +row.sms_rendering_type; field = 'sms'; break;
            case DELIVERY_METHOD_CHAT: rt = +row.chat_rendering_type; field = 'chat'; break;
            case DELIVERY_METHOD_WHATSAPP: rt = +row.whatsapp_rendering_type; field = 'whatsapp'; break;
            case DELIVERY_METHOD_AIRBNB: rt = +row.airbnb_rendering_type; field = 'airbnb'; break;
            default: rt = RENDERING_TYPE_CUSTOM;
        }
        return {
            rendering_type: isNaN(rt) ? RENDERING_TYPE_CUSTOM : rt,
            prefix: field
        }
    }

    const onStandardTemplateSettingsOpen = (ev, row) => {
        setNfSettingsRow(row);
    }

    const onStandardTemplateSettingsClose = () => {
        setNfSettingsRow(null);
    }

    const onStandardTemplateSettingsChange = (settings) => {
        console.log('standard nf settings change', settings);
        setNotification((prev) => {
            let delivery_methods = prev.delivery_methods;
            let upd = delivery_methods.filter((dm) => dm.id === nfSettingsRow.id)[0];
            upd = {
                ...upd,
                ...settings
            }
            return {
                ...prev,
                delivery_methods: [...delivery_methods.filter((dm) => dm.id !== nfSettingsRow.id), upd].sort(compare),
            };
        });

    }

    return (
        <>
            {confirmationDialogAction ? (
                <ConfirmationDialog
                    keepMounted
                    onCancel={confirmationDialogCancel}
                    onConfirm={confirmationDialogConfirm}
                    title={ConfirmationDialogText[confirmationDialogAction].title}
                    okButtonText={ConfirmationDialogText[confirmationDialogAction].okButtonText}
                    cancelButtonText={ConfirmationDialogText[confirmationDialogAction].cancelButtonText}
                    open={!!confirmationDialogAction}
                >
                    {ConfirmationDialogText[confirmationDialogAction].body}
                </ConfirmationDialog>
            ) : null}
            {httpHeadersDialogOpen != null && (
                <Dialog
                    open={true}
                    onClose={() => {
                        setHttpHeadersDialogOpen(null);
                        setHeadersEditError(null);
                    }}
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogTitle>Edit HTTP request</DialogTitle>
                    <DialogContent>
                        <TextField
                            value={headersEditValue}
                            onChange={ev => {
                                setHeadersEditValue(ev.target.value);
                                setHeadersEditError(null);
                            }}
                            multiline
                            minRows={6}
                            maxRows={16}
                            fullWidth
                            variant="outlined"
                            label="HTTP Headers"
                            error={!!headersEditError}
                            helperText={headersEditError}
                        />
                    </DialogContent>
                    <DialogActions>
                        <FormActionButtons
                            mode="edit"
                            size="medium"
                            onSubmit={() => onHttpHeadersChange(httpHeadersDialogOpen)}
                            onCancel={() => {
                                setHttpHeadersDialogOpen(null);
                                setHeadersEditError(null);
                            }}
                        />
                    </DialogActions>
                </Dialog>
            )}
            {!!nfSettingsRow && (<StandardNotificationSettingsDialog
                open={!!nfSettingsRow}
                onClose={onStandardTemplateSettingsClose}
                onChange={onStandardTemplateSettingsChange}
                event={notification.event}
                title={`${nfSettingsRow.option_str}: ${DELIVERY_METHODS[nfSettingsRow.method].toLowerCase()} notification settings`}
                data={nfSettingsRow}
                readOnly={!hasPerm('notification', 'write')}
            />)}
            <Grid item xs={12} m={isSmallScreen ? 0 : 2} mt={2} className={classes.toolbarContainer} container>
                {/* //ToolBar */}
                <Grid container style={{ width: '100%' }} alignItems="center" p={2}>
                    <Grid item xs={12} lg={4}>
                        <Typography style={{ color: '#202020' }} fontSize={20} fontWeight={500}>
                            Delivery
                        </Typography>
                    </Grid>
                        <Grid item container xs={12} lg={8} justifyContent={isSmallScreen ? 'space-between' : 'end'} alignItems="center" spacing={1}>
                            <Grid item>
                                <Autocomplete
                                    disabled={disabled}
                                    options={deliveryMethodsShown()}
                                    getOptionLabel={(opt) => opt.name}
                                    onChange={handleNewDeliveryMethodTypeChange}
                                    renderInput={(params) => <TextField {...params} value={DELIVERY_METHODS[newDeliveryMethod.method]} variant="filled" size="small" color="primary" label="Select delivery method" style={{ width: '214px' }} />}
                                />
                            </Grid>
                            <Grid item>
                            <Button color="primary" disabled={newDeliveryMethod.method === null || disabled} variant="outlined" onClick={handleAddNewDeliveryMethod}>
                                    <AddIcon fontSize="small"/>&nbsp;Add
                                </Button>
                            </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item xs={12}>
                    <RecordList
                        className={classes.recordList}
                        disableSelectionOnClick={true}
                        sortModel={[{ field: 'name', sort: 'asc' }]}
                        autorefresh={false}
                        deps={lastUpdate}
                        listItemRenderer={listItemRenderer}
                        disableListBorder={true}
                        checkboxSelection={false}
                        staticOptions={isAdmin ? notification.delivery_methods : notification.delivery_methods.filter((dm) => NON_ADMIN_DELIVERY_METHODS.indexOf(dm.method) >= 0)}
                        rowHeight={125}
                        relatedLoading={relatedLoading}
                        onRowOrderUpdate={onRowOrderUpdate}
                        columns={[
                            {
                                field: 'option_str',
                                headerName: 'Method',
                            },
                            !disabled && {
                                field: 'sequence',
                                headerName: 'Sequence',
                                type: 'reorder',
                            },
                            {
                                field: 'method',
                                headerName: 'Method',
                                sortable: false,
                                flex: 0.5,
                                renderCell: (p) => {
                                    return (
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                gap: '0.5rem',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    backgroundColor: '#F1F1F2',
                                                    borderRadius: '2px',
                                                    padding: '0.15rem 0.4rem',
                                                    opacity: 0.85,
                                                }}
                                            >
                                                <Typography>{DELIVERY_METHODS[p.row.method]}</Typography>
                                            </div>
                                        </div>
                                    );
                                },
                            },
                            {
                                field: 'recipient',
                                headerName: 'Recipient',
                                sortable: false,
                                flex: 0.6,
                                renderCell: formatRecipientBasedOnMethod,
                            },
                            {
                                field: 'rendering_type',
                                headerName: 'Template type',
                                sortable: false,
                                filterable: false,
                                flex: 0.3,
                                renderCell: (p) => {
                                    if (p.row.method === DELIVERY_METHOD_HTTP_REQUEST) {
                                        return (<FormControl variant="outlined" size="small" fullWidth disabled={props.disabled}>
                                            <InputLabel>HTTP method</InputLabel>
                                            <Select 
                                                value={p.row.http_method}
                                                onChange={(ev) => onHttpMethodChange(p.row, ev.target.value)}
                                                size="small" variant="filled" color="primary">
                                                { httpMethodMenuItems}
                                            </Select>
                                        </FormControl>)
                                    }
                                    const rt = getRowRenderingType(p.row);
                                    return (<>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={rt.rendering_type === RENDERING_TYPE_CUSTOM}
                                                    onChange={(ev) => onToggleRenderingType(p.row, `${rt.prefix}_rendering_type`, ev)}
                                                />
                                            }
                                            label={<Typography>Custom</Typography>}
                                        />
                                    </>)
                                }
                            },
                            {
                                field: 'template',
                                headerName: 'Template',
                                sortable: false,
                                filterable: false,
                                flex: 0.6,
                                renderCell: (p) => {
                                    if (p.row.method === DELIVERY_METHOD_HTTP_REQUEST) {
                                        return <Button
                                            variant="outlined"
                                            size="small"
                                            style={{ marginLeft: 8 }}
                                            onClick={() => {
                                                setHttpHeadersDialogOpen(p.row.id);
                                                setHeadersEditValue(
                                                    p.row.http_headers
                                                        ? JSON.stringify(p.row.http_headers, null, 2)
                                                        : '{\n  \n}'
                                                );
                                                setHeadersEditError(null);
                                            }}
                                            disabled={props.disabled}
                                        >
                                            <EditIcon fontSize="small" />&nbsp;Edit Headers
                                        </Button>
                                    }
                                    const rt = getRowRenderingType(p.row);
                                    return (<>
                                        { rt.rendering_type === RENDERING_TYPE_STANDARD && (<>
                                            <Grid container direction="row" spacing={2}>
                                                <Grid item xs={10}>
                                                    <FormControl 
                                                        fullWidth 
                                                        variant="filled" 
                                                        size="small" 
                                                        disabled={props.disabled} 
                                                        error={!p.row[`${rt.prefix}_template`]}
                                                    >
                                                        <StandardRemoteAutocomplete
                                                            getOptionLabel={(opt) => `${opt.name} (v${opt.version})`}
                                                            apiParams={{ method: p.row.method }}
                                                            resource="notification"
                                                            urlSuffix={"list_standard_templates/"}
                                                            label="Standard Template"
                                                            variant="filled"
                                                            size="small"
                                                            fullWidth
                                                            onChange={(ev, nv, reason) => onStandardTemplateSelect(p.row, nv, `${rt.prefix}_template`, reason)}
                                                            value={p.row[`${rt.prefix}_template`]}
                                                            disabled={props.disabled}
                                                            error={!p.row[`${rt.prefix}_template`]}
                                                        />
                                                        {!p.row[`${rt.prefix}_template`] && (
                                                            <FormHelperText>Please select standard template</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <Tooltip title="Template settings">
                                                        <span>
                                                            <IconButton
                                                                color="primary"
                                                                disabled={disabled}
                                                                onClick={(ev) => onStandardTemplateSettingsOpen(ev, p.row)}
                                                            >
                                                                    <SettingsIcon/>
                                                            </IconButton>
                                                        </span>
                                                    </Tooltip>
                                                </Grid>
                                            </Grid></>) }
                                        { rt.rendering_type === RENDERING_TYPE_CUSTOM && (
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                size="small"
                                                disabled={disabled}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    history.push('/notifications/' + notification.id + '/' + p.row.id);
                                                }}
                                            >
                                                <EditIcon fontSize="small" />&nbsp;Edit custom template
                                            </Button>
                                        )}
                                    </>)
                                }
                            },
                            {
                                field: 'buttons',
                                headerName: 'Action',
                                sortable: false,
                                width: 225,
                                renderCell: (p) => {
                                    return (
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '0.35rem',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            {/* <Link href={'/notifications/' + notification.id + '/' + p.row.id}> */}
                                            {/* <IconButton
                                                color="primary"
                                                disabled={disabled}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    history.push('/notifications/' + notification.id + '/' + p.row.id);
                                                }}
                                            >
                                                <EditIcon />
                                            </IconButton> */}
                                            {/* </Link > */}
                                            <Tooltip title="Duplicate">
                                                <span>
                                                    <IconButton disabled={disabled} onClick={() => onDuplicate(p?.row?.id)}>
                                                        <ContentCopyIcon color={!disabled ? "primary" : 'gray'} />
                                                    </IconButton>
                                                </span>
                                            </Tooltip>
                                            <DeleteIconButton size="medium" disabled={disabled} onClick={(ev) => handleDeleteDeliveryMethod(ev, p.row.id)} />
                                            <div>
                                                <Switch
                                                    disabled={disabled}
                                                    checked={p?.row?.enabled}
                                                    onChange={(e) => {
                                                        onRecordListSwitchChange(e, p?.row.id);
                                                    }}
                                                    name="enabled"
                                                    color="primary"
                                                />
                                            </div>
                                        </div>
                                    );
                                },
                            },
                        ]}
                    />
                </Grid>
            </Grid >
            <Grid item xs={12} container p={1} pr={2} spacing={1} alignItems="center" >
                <Grid item xs={12} sm={4} md={3.5} lg={3} xl={2.5} container alignItems="center" flexWrap="nowrap" >
                    <Radio
                        disabled={disabled}
                        value={DELIVERY_ALL}
                        // defaultChecked={true}
                        checked={notification.delivery_method_ordering === DELIVERY_ALL}
                        onClick={() =>
                            setNotification((prev) => ({
                                ...prev,
                                delivery_method_ordering: DELIVERY_ALL,
                            }))
                        }
                    />
                    <Typography>{DELIVERY_ORDERING[DELIVERY_ALL]}</Typography>
                </Grid>
                <Grid item xs={12} sm={4} md={3.5} lg={3} xl={2.5} container alignItems="center" flexWrap="nowrap">
                    <Radio
                        disabled={disabled}
                        value={DELIVERY_FIRST}
                        onClick={() =>
                            setNotification((prev) => ({
                                ...prev,
                                delivery_method_ordering: DELIVERY_FIRST,
                            }))
                        }
                        checked={notification.delivery_method_ordering === DELIVERY_FIRST}
                    />
                    <Typography>{DELIVERY_ORDERING[DELIVERY_FIRST]}</Typography>
                </Grid>
                <Grid item xs={12} sm={4} md={3.5} lg={3} xl={2.5} container alignItems="center" flexWrap="nowrap">
                    <Radio
                        disabled={disabled}
                        value={DELIVERY_ADVANCED}
                        onClick={() =>
                            setNotification((prev) => ({
                                ...prev,
                                delivery_method_ordering: DELIVERY_ADVANCED,
                            }))
                        }
                        checked={notification.delivery_method_ordering === DELIVERY_ADVANCED}
                    />
                    <Typography>{DELIVERY_ORDERING[DELIVERY_ADVANCED]}</Typography>
                </Grid>
            </Grid>
        </>
    );
};

export default DeliveryMethodList;
